<template>
  <transition name="toast-fade">
    <div
      v-if="visible"
      class="app-toast"
      :class="`app-toast--${type}`"
      role="status"
      data-test="app-toast"
    >
      <font-awesome-icon
        :icon="['fas', iconName]"
        class="app-toast__icon"
      />
      <span class="app-toast__message" data-test="app-toast-message">
        {{ message }}
      </span>
      <button
        type="button"
        class="app-toast__close"
        aria-label="close"
        data-test="app-toast-close"
        @click="hide"
      >
        <font-awesome-icon :icon="['fas', 'times']" />
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      visible: false,
      message: "",
      type: "success",
      timer: null
    };
  },
  computed: {
    iconName() {
      if (this.type === "error") return "times-circle";
      if (this.type === "warning") return "exclamation-circle";
      return "check-circle";
    }
  },
  methods: {
    show({ message, type = "success", duration = 3000 } = {}) {
      this.message = message || "";
      this.type = type;
      this.visible = true;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => this.hide(), duration);
    },
    hide() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.app-toast {
  position: fixed;
  top: 16px;
  left: 50%;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  width: calc(100% - 32px);
  max-width: 480px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  transform: translateX(-50%);
  font-size: var(--font-body);
}

.app-toast--success {
  border-left: 4px solid #2ecc71;
}

.app-toast--error {
  border-left: 4px solid #e74c3c;
}

.app-toast--warning {
  border-left: 4px solid #f39c12;
}

.app-toast__icon {
  flex-shrink: 0;
  font-size: 20px;
}

.app-toast--success .app-toast__icon {
  color: #2ecc71;
}

.app-toast--error .app-toast__icon {
  color: #e74c3c;
}

.app-toast--warning .app-toast__icon {
  color: #f39c12;
}

.app-toast__message {
  flex: 1;
  color: #2f2f2f;
  line-height: 1.4;
}

.app-toast__close {
  flex-shrink: 0;
  padding: 4px;
  border: 0;
  background: transparent;
  color: #9a9a9a;
  cursor: pointer;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -8px);
}
</style>
